import { createEntityAdapter } from "@reduxjs/toolkit";
import { ServiceTypeCategory } from "./dataTypes";

export const serviceTypeCategoryAdapter = createEntityAdapter<ServiceTypeCategory>({});
